import * as React from "react";
import { connect } from "react-redux";
import "./qnot.css";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { Modal, Button } from "react-bootstrap";
import { GetURIByParts } from "../../services/Utils/StringUtils";
import NotificationEditForm from "./NotificationEditForm";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { DateRangePicker } from "react-dates";
import LookupValueSelectList from "../LookupValueSelectList/LookupValueSelectList";
import { LookupValueTypes } from "../LookupValueSelectList/lookupValueTypes";
import {
  IExportColumnMap,
  INotification,
  NotificationStatus,
  PagedResultsRequest
} from "../../common/sharedTypes";
import { toast } from "react-toastify";
import "./qnot.css";
import {
  getPagedNotifications,
  getNotificationsPaged,
  saveUpdatedPagedNotification,
  sendPagedNotifications,
  removePagedNotifications,
  setLoadingNotifications,
  setTotalNotifications,
  getNotification
} from "./redux-objects/actions";
import AdhocNotificationButton from "../Notifications/AdhocNotification/AdhocNotificationButton";
import PagedDatatable from "../PagedDataTable";
import { TableColumn } from "react-data-table-component/dist/DataTable/types";
import {
  QueuedNotificationSearchItem,
  QueuedNotificationSearchPagedRequest
} from "./business-objects/common";
import LocalStorageUtils from "../WorkflowQueues/common/LocalStorageUtils";

export interface IQueuedNotificationsPagedActionProps {
  getNotificationsPaged?: (
    url: string,
    request: QueuedNotificationSearchPagedRequest
  ) => void;
  sendPagedNotifications?: (
    url: string,
    ids: number[],
    callback: () => void
  ) => void;
  removePagedNotifications?: (
    url: string,
    ids: number[],
    callback: () => void
  ) => void;
  saveUpdatedPagedNotification?: (
    url: string,
    notification: INotification,
    callback: () => void
  ) => void;
  setPagedNotifications?: (
    notificaitons: QueuedNotificationSearchItem[]
  ) => void;
  setLoadingNotifications?: (value: boolean) => void;
  setTotalNotifications?: (value: number) => void;
}

interface IQueuedNotificationsPagedStateProps {
  notifications: QueuedNotificationSearchItem[];
  webServiceURL: string;
  totalNotifications: number;
  loadingNotifications: boolean;
}

interface IQueuedNotificationProps
  extends IQueuedNotificationsPagedActionProps,
    IQueuedNotificationsPagedStateProps {}

enum ModalMode {
  None,
  New,
  Editing
}

enum ServiceEndPoints {
  GetNotifications = "GetNotifications",
  GetNotification = "GetNotification",
  GetNotificationsPaged = "GetNotificationsPaged",
  PutNotification = "PutNotification",
  SendNotifications = "SendNotifications",
  RemoveNotifications = "RemoveNotifications"
}

class QueuedNotificationsPaged extends React.Component<
  IQueuedNotificationProps,
  any
> {
  private editForm: any = React.createRef();
  private startDateVariable: string = "QueuedNotificationsStartDate";
  private endDateVariable: string = "QueuedNotificationsEndDate";

  private userOnlyVariable: string = "QueuedNotificationsUserOnly";
  private notificationTypeIdVariable: string =
    "QueuedNotificationsNotificationTypeId";
  private reportTypeIdVariable: string = "QueuedNotificationsReportTypeId";

  public constructor(props: IQueuedNotificationProps) {
    super(props);
    this.state = {
      userOnly:
        LocalStorageUtils.getLocalStorage(this.userOnlyVariable) != null
          ? LocalStorageUtils.getLocalStorageBool(this.userOnlyVariable)
          : true,
      startDate: moment(
        moment().startOf("month").format("DD/MM/YYYY"),
        "DD/MM/YYYY"
      ), // moment('1/2/2019', 'DD/MM/YYYY'),
      endDate: moment(
        moment().endOf("month").format("DD/MM/YYYY"),
        "DD/MM/YYYY"
      ), //moment('28/2/2019', 'DD/MM/YYYY'),
      notificationTypeId:
        LocalStorageUtils.getLocalStorage(this.notificationTypeIdVariable) ||
        "-1",
      reportTypeId:
        LocalStorageUtils.getLocalStorage(this.reportTypeIdVariable) || "-1",
      focusedInput: null,
      showModal: false,
      modalStatus: ModalMode.None,
      currentNotification: null,
      selectedRows: [],
      pagingCriteria: {
        itemsPerPage: 10,
        pageNumber: 1,
        searchCriteria: null,
        orderByField: "Id",
        orderDescending: false
      }
    };
  }

  // TODO: Refactor to configuration file
  private notificationServiceController: string = "Notification";

  componentDidMount() {
    this.populateNotifications();
  }

  closeModal = (e?) => {
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.None,
      showModal: false,
      currentNotification: null
    });
  };

  toggleScrollLock = () => {
    document.querySelector("html").classList.toggle("scroll-lock");
  };

  handleSendSelected(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault();
    if (this.state.selectedRows.length === 0) {
      toast.error("No Notificaitons Selected");
      return;
    }
    const ids = this.state.selectedRows.map((r) => r.id);
    this.props.sendPagedNotifications(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.SendNotifications
      ),
      ids,
      () => {
        this.populateNotifications();
      }
    );
  }

  handleSendOne(row: QueuedNotificationSearchItem) {
    this.props.sendPagedNotifications(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.SendNotifications
      ),
      [row.id],
      () => {
        this.populateNotifications();
      }
    );
  }

  handleRemoveOne(row: QueuedNotificationSearchItem) {
    this.props.removePagedNotifications(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.RemoveNotifications
      ),
      [row.id],
      () => {
        this.populateNotifications();
      }
    );
  }
  handleRemoveSelected(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault();
    if (this.state.selectedRows.length === 0) {
      toast.error("No Letters Selected");
      return;
    }
    const ids = this.state.selectedRows.map((r) => r.id);

    this.props.removePagedNotifications(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.RemoveNotifications
      ),
      ids,
      () => {
        this.populateNotifications();
      }
    );
  }

  handleEdit = async (row: QueuedNotificationSearchItem) => {
    try {
      let uri = GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.GetNotification
      );
      uri = uri + "?id=" + row.id;

      const response = await getNotification(uri);

      if (response.ok) {
        this.toggleScrollLock();
        this.setState({
          modalStatus: ModalMode.Editing,
          showModal: true,
          currentNotification: response.data
        });
      }
    } catch (ex) {
      toast.error("Unable to retreive notification.");
      console.log(ex);
    }
  };

  handleUserCheck(userChecked) {
    LocalStorageUtils.setLocalStorageItem(this.userOnlyVariable, userChecked);
    this.setState({ userOnly: userChecked }, () => {
      this.populateNotifications();
    });
  }

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      LocalStorageUtils.setLocalStorageItem(this.startDateVariable, startDate);
      LocalStorageUtils.setLocalStorageItem(this.endDateVariable, endDate);
      this.setState({ startDate, endDate }, () => {
        this.populateNotifications();
      });
    }
  }

  handleNotificationTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    LocalStorageUtils.setLocalStorageItem(
      this.notificationTypeIdVariable,
      value
    );
    this.setState({ notificationTypeId: value }, () => {
      this.populateNotifications();
    });
  }

  handleReportTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    LocalStorageUtils.setLocalStorageItem(this.reportTypeIdVariable, value);
    this.setState({ reportTypeId: value }, () => {
      this.populateNotifications();
    });
  }

  refreshNotifications() {
    this.populateNotifications();
  }
  populateNotifications() {
    const uri = GetURIByParts(
      this.props.webServiceURL,
      this.notificationServiceController,
      ServiceEndPoints.GetNotificationsPaged
    );
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );

    const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
      this.userOnlyVariable
    );
    const persistentNotificationTypeId = LocalStorageUtils.getLocalStorage(
      this.notificationTypeIdVariable
    );

    const persistentReportTypeId = LocalStorageUtils.getLocalStorage(
      this.reportTypeIdVariable
    );

    const request: QueuedNotificationSearchPagedRequest = {
      ...this.state.pagingCriteria,
      userOnly: persistentUserOnly || this.state.userOnly,
      startDate: persistentStartDate
        ? persistentStartDate.toDate()
        : this.state.startDate.toDate(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate()
        : this.state.endDate.toDate(),
      notificationTypeId: persistentNotificationTypeId
        ? Number(persistentNotificationTypeId)
        : Number(this.state.notificationTypeId),
      reportTypeId: persistentReportTypeId
        ? Number(persistentReportTypeId)
        : Number(this.state.reportTypeId),
      statusId: NotificationStatus.QUEUED,
      reportsOnly: true
    };

    this.props.getNotificationsPaged(uri, request);
  }

  getExportData = async () => {
    const uri = GetURIByParts(
      this.props.webServiceURL,
      this.notificationServiceController,
      ServiceEndPoints.GetNotificationsPaged
    );
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );

    const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
      this.userOnlyVariable
    );
    const persistentNotificationTypeId = LocalStorageUtils.getLocalStorage(
      this.notificationTypeIdVariable
    );

    const persistentReportTypeId = LocalStorageUtils.getLocalStorage(
      this.reportTypeIdVariable
    );

    const request: QueuedNotificationSearchPagedRequest = {
      ...this.state.pagingCriteria,
      itemsPerPage: this.props.totalNotifications,
      pageNumber: 1,
      userOnly: persistentUserOnly || this.state.userOnly,
      startDate: persistentStartDate
        ? persistentStartDate.toDate()
        : this.state.startDate.toDate(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate()
        : this.state.endDate.toDate(),
      notificationTypeId: persistentNotificationTypeId
        ? Number(persistentNotificationTypeId)
        : Number(this.state.notificationTypeId),
      reportTypeId: persistentReportTypeId
        ? Number(persistentReportTypeId)
        : Number(this.state.reportTypeId),
      statusId: NotificationStatus.QUEUED,
      reportsOnly: true
    };

    const response = await getPagedNotifications(uri, request);

    if (response.ok) {
      return response.data?.notifications || [];
    }
    return [];
  };

  onSaveNotification = async (e) => {
    let updatedNotification: INotification =
      this.editForm.getUpdatedNotification();

    await this.props.saveUpdatedPagedNotification(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.PutNotification
      ),
      updatedNotification,
      () => {
        this.populateNotifications();
      }
    );

    this.closeModal();
    toast.success("Saved!");
  };

  selectedRowsChanged = (selectedRows: QueuedNotificationSearchItem[]) => {
    this.setState({ selectedRows });
  };

  handlePagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ pagingCriteria: pagingCriteria as any }, () => {
      this.populateNotifications();
    });
  };

  handleClearDateSelection = (): void => {
    LocalStorageUtils.removeLocalStorageItem(this.startDateVariable);
    LocalStorageUtils.removeLocalStorageItem(this.endDateVariable);
    this.setState(
      {
        startDate: moment(
          moment().startOf("month").format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        ), // moment('1/2/2019', 'DD/MM/YYYY'),
        endDate: moment(
          moment().endOf("month").format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        )
      },
      () => {
        this.populateNotifications();
      }
    );
  };

  columns: TableColumn<QueuedNotificationSearchItem>[] = [
    {
      name: "AVAILABLE ACTIONS",
      selector: (row) => row?.id,
      sortField: "Id",
      sortable: true,
      wrap: true,
      format: (row: QueuedNotificationSearchItem) => {
        return (
          <div>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={(e) => this.handleSendOne(row)}
            >
              {" "}
              Send
            </Button>
            {"  "}
            <Button
              variant="outline-warning"
              size="sm"
              onClick={(e) => this.handleEdit(row)}
            >
              {" "}
              Edit{" "}
            </Button>
            {"  "}
            <Button
              variant="outline-danger"
              size="sm"
              onClick={(e) => this.handleRemoveOne(row)}
            >
              {" "}
              Remove{" "}
            </Button>
          </div>
        );
      }
    },
    {
      name: "DATE REQUESTED",
      sortable: true,
      sortField: "CreatedDate",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) =>
        row?.createdDate
          ? moment(row.createdDate).format("MMM D, yyyy h:mmA")
          : ""
    },
    {
      name: "TEMPLATE",
      sortField: "NotificationTemplatename",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) =>
        row?.notificationTemplateName || "",
      sortable: true
    },
    {
      name: "SUBJECT",
      sortField: "Subject",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) => row?.subject || "",
      sortable: true
    },
    {
      name: "SENT TO",
      sortField: "SentTo",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) => row?.sentTo || "",
      sortable: true
    },
    {
      name: "REQUESTED BY",
      sortField: "CreatedByUserName",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) =>
        row?.createdByUserName || "",
      sortable: true
    },
    {
      name: "LETTER TYPE",
      sortField: "NotificationTypeName",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) =>
        row?.notificationTypeName || "",
      sortable: true
    }
  ];

  exportColumnMaps: IExportColumnMap[] = [
    { columnName: "ID", propertyName: "id" },
    {
      columnName: "DATE REQUESTED",
      propertyName: "createdDate",
      convertMethod: (val) => moment(val).format("MM/DD/YYYY hh:mma")
    },
    { columnName: "TEMPLATE", propertyName: "notificationTemplateName" },
    { columnName: "SUBJECT", propertyName: "subject" },
    { columnName: "SEND TO", propertyName: "sentTo" },
    { columnName: "REQUESTED BY", propertyName: "createdByUserName" },
    { columnName: "LETTER TYPE", propertyName: "notificationTypeName" }
  ];

  public render() {
    return (
      <div className="app">
        <div className="row">
          <div className="col-sm-6">
            <h3>Queued Letters</h3>
          </div>
          <div className="col-sm-6">
            <AdhocNotificationButton
              className="float-right"
              onSave={() => this.refreshNotifications()}
            />
          </div>
        </div>

        <hr />
        <Form>
          <Form.Group controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label=" Show only Letters I created"
              checked={
                LocalStorageUtils.getLocalStorageBool(this.userOnlyVariable) ||
                this.state.userOnly
              }
              onChange={(e) => this.handleUserCheck(e.target.checked)}
            />
          </Form.Group>
          <Form.Row>
            <Form.Group as={Col} controlId="queuedNotificationsStartDate">
              <Form.Label>Created Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={
                  LocalStorageUtils.getLocalStorageDate(
                    this.startDateVariable
                  ) || this.state.startDate
                }
                startDateId="queuedNotificationsStartDate" // PropTypes.string.isRequired,
                endDate={
                  LocalStorageUtils.getLocalStorageDate(this.endDateVariable) ||
                  this.state.endDate
                }
                endDateId="queuedNotificationsEndDate" // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
              {(LocalStorageUtils.getLocalStorageDate(this.startDateVariable) ||
                LocalStorageUtils.getLocalStorageDate(
                  this.endDateVariable
                )) && (
                <button
                  className="btn btn-outline-danger btn-sm"
                  style={{ fontSize: "14px", marginLeft: "5px" }}
                  title="Clear Date Filter"
                  onClick={this.handleClearDateSelection}
                >
                  <i className="fa fa-calendar-xmark" />
                </button>
              )}
            </Form.Group>

            <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
              <Form.Label>Letter Type</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleNotificationTypeChange(e)}
                value={
                  LocalStorageUtils.getLocalStorage(
                    this.notificationTypeIdVariable
                  ) || this.state.notificationTypeId
                }
                type={LookupValueTypes.NOTIFICATION_TYPES}
                includeAll={true}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="exampleForm.ControlSelect2">
              <Form.Label>Report Type</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleReportTypeChange(e)}
                value={
                  LocalStorageUtils.getLocalStorage(
                    this.reportTypeIdVariable
                  ) || this.state.reportTypeId
                }
                type={LookupValueTypes.REPORT_TYPES}
                includeAll={true}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row />
          <Form.Row>
            <Form.Group as={Col}>
              <Button
                id="btnSendSelected"
                type="button"
                className="btn btn-primary"
                onClick={(e) => this.handleSendSelected(e)}
              >
                Send Selected
              </Button>
              {"   "}
              <Button
                id="btnRemoveSelected"
                type="button"
                className="btn btn-danger"
                onClick={(e) => this.handleRemoveSelected(e)}
              >
                Remove Selected
              </Button>
            </Form.Group>
          </Form.Row>
        </Form>
        <PagedDatatable
          columns={this.columns}
          data={this.props.notifications || []}
          loadingData={this.props.loadingNotifications}
          totalDataItems={this.props.totalNotifications}
          exportTitle="Queued Letters"
          exportFileName="QueuedLetters"
          exportColumnMaps={this.exportColumnMaps}
          pagingCriteria={this.state.pagingCriteria}
          updatePagedResults={this.handlePagingCriteriaChange}
          getExportData={this.getExportData}
          selectableRows={true}
          onSelectedRowsChanged={this.selectedRowsChanged}
        ></PagedDatatable>
        <Modal show={this.state.showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {" "}
              {this.state.modalStatus == ModalMode.New
                ? "Create Notification"
                : "Edit Notification"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <NotificationEditForm
              notificationToEdit={this.state.currentNotification}
              ref={(ef) => (this.editForm = ef)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Close
            </Button>
            <Button variant="primary" onClick={this.onSaveNotification}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    notifications: state.qnotification.pagedNotifications,
    webServiceURL: state.Application.backendURL,
    loadingNotifications: state.qnotification.loadingNotifications,
    totalNotifications: state.qnotification.totalNotifications
  };
}

const mapDispatchToProps = {
  getNotificationsPaged,
  saveUpdatedPagedNotification,
  sendPagedNotifications,
  removePagedNotifications,
  setLoadingNotifications,
  setTotalNotifications
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QueuedNotificationsPaged);
